import { render, staticRenderFns } from "./Address_list.vue?vue&type=template&id=32f202ba&scoped=true"
import script from "./Address_list.vue?vue&type=script&lang=js"
export * from "./Address_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f202ba",
  null
  
)

export default component.exports